const cleanURL = (url = '') => (url ? url.replace(/&amp;/g, '&') : url);
export default cleanURL;
